<template>
  <div>
    <warehouse-new-page ref="warehouseNewPage" :context="context" :action="action" />
    <trucking-page v-if="job.loadingTerm == 'DD'" ref="truckingPage" :context="context" :action="action" />
  </div>
</template>

<script>
import truckingPage from '@/components/Cargo/Warehouse/truckingPage'
import warehouseNewPage from '@/components/Cargo/Warehouse/warehouseNewPage'
import { AirExportJob } from '@/class/model/booking/AirExportJob'

export default {
  name: 'TabWarehouseTrucking',
  components: { truckingPage, warehouseNewPage },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      job: {}
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      this.$refs.warehouseNewPage.onShow(row, isRefresh)
      if (this.job.loadingTerm === 'DD') {
        this.$nextTick(() => {
          this.$refs.truckingPage.onShow(row, isRefresh)
        })
      }
    },
    async getSubmitData() {
      const warehouseData = this.$refs.warehouseNewPage.getSubmitData()
      if (this.job.loadingTerm !== 'DD') {
        return warehouseData
      } else {
        const truckingPageData = this.$refs.truckingPage.getSubmitData()
        const datas = [warehouseData, truckingPageData]
        const body = {}
        // 将不同页签相同key的集合进行数据合并
        for (let tabData of datas) {
          if (!tabData) continue
          if (tabData instanceof Promise) {
            tabData = await tabData
          }
          for (const key in tabData) {
            const tabValue = tabData[key]
            if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
            const bodyValue = body[key]
            if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
            // 将数组进行合并
            if (Array.isArray(tabValue)) {
              if (Array.isArray(bodyValue)) {
                const bodyMap = new Map()
                if (bodyValue.length > 0) {
                  for (const bodyKey of bodyValue) {
                    if (!bodyKey) continue
                    if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                  }
                }
                if (tabValue.length > 0) {
                  for (const tabKey of tabValue) {
                    if (!tabKey || bodyValue.includes(tabKey)) continue
                    if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                    bodyValue.push(tabKey)
                  }
                }
              } else {
                tabValue.push(bodyValue)
                body[key] = tabValue
              }
              delete tabData[key]
            }
          }
          Object.assign(body, tabData)
        }
        return body
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.JOB_UUID = this.job.uuid
      params.category = 'AELOCALSERVICE'
      if (this.$refs.truckingPage && this.$refs.truckingPage.truckingInfo) {
        params.TRUCKING_UUID = this.$refs.truckingPage.truckingInfo.uuid
      } else {
        params.TRUCKING_UUID = null
      }
      params.ctx = new AirExportJob(this.job)
      return params
    }
  }
}
</script>

<style>
</style>
